var Accordion = function($element, options){
    this.element = $element;

    this.defaults = {
        singleActiveItem: false,
        activeIndex: undefined,
        fromWidth: 0,
    };
    this.options = jQuery.extend({}, this.defaults, options);

    this.items = this.element.find('> [data-role="accordion-item"]');
    this.instanceId = 'accordion-' + Math.random().toString(36).substr(2, 9);

    if (this.items.length) {
        this.init();
    }
};

Accordion.prototype = {
    defaults: {},
    windowWidth: undefined,
    init: function ()
    {
        this.windowWidth = window.innerWidth;
        this.setupAccessibility();

        if (this.options.activeIndex != undefined) {
            this.activate(this.options.activeIndex);
        }

        this.addDOMEvents();
    },
    addDOMEvents: function() {
        var _self = this;

        this.items.children('[data-role="accordion-title"]').on('click', function() {
            if (!_self.options.fromWidth || (_self.options.fromWidth && _self.options.fromWidth >= _self.windowWidth)) {
                _self.activate($(this).closest('[data-role="accordion-item"]').index());
            }
        });

        this.items.children('[data-role="accordion-title"]').on('keydown keyup', function(event) {
            var isEnter = event.key === 'Enter' || event.keyCode === 13;
            var isSpace = event.key === ' ' || event.key === 'Spacebar' || event.code === 'Space' || event.keyCode === 32;

            if ((event.type === 'keydown' && !isEnter) || (event.type === 'keyup' && !isSpace)) {
                return;
            }

            event.preventDefault();

            if (!_self.options.fromWidth || (_self.options.fromWidth && _self.options.fromWidth >= _self.windowWidth)) {
                _self.activate($(this).closest('[data-role="accordion-item"]').index());
            }
        });

        if (typeof _self.options.fromWidth !== 'undefined') {
            var resizeFn = debounce(function () {
                if (_self.windowWidth != window.innerWidth) {
                    _self.windowWidth = window.innerWidth;

                    if (_self.windowWidth > _self.options.fromWidth) {
                        _self.remove();
                    }
                }
            }, 100);

            window.addEventListener('resize', resizeFn);
        }
    },
    activate: function(index) {

        var _self = this;
        var act = this.items.get(index);

        if (act) {
            var item = $(act);
            var content = item.children('[data-role="accordion-content"]');
            var title = item.children('[data-role="accordion-title"]');
            var isExpanded = item.hasClass('active');

            if (isExpanded) {
                item.removeClass('active');
                title.attr('aria-expanded', 'false');
                content.attr('aria-hidden', 'true').slideUp();
                return;
            }

            if (this.options.singleActiveItem) {
                this.items.not(item).each(function() {
                    var otherItem = $(this);
                    otherItem.removeClass('active');
                    otherItem.children('[data-role="accordion-title"]').attr('aria-expanded', 'false');
                    otherItem.children('[data-role="accordion-content"]').attr('aria-hidden', 'true').slideUp();
                });
            }

            item.addClass('active');
            title.attr('aria-expanded', 'true');
            content.attr('aria-hidden', 'false').slideDown();
        }
    },
    setupAccessibility: function() {
        var _self = this;

        this.items.each(function(index) {
            var item = $(this);
            var title = item.children('[data-role="accordion-title"]');
            var content = item.children('[data-role="accordion-content"]');
            var titleId = _self.instanceId + '-title-' + index;
            var contentId = _self.instanceId + '-content-' + index;
            var isActive = item.hasClass('active');

            title.attr({
                role: 'button',
                tabindex: 0,
                'aria-controls': contentId,
                'aria-expanded': isActive ? 'true' : 'false'
            });

            if (!title.attr('id')) {
                title.attr('id', titleId);
            }

            content.attr({
                id: contentId,
                'aria-labelledby': title.attr('id'),
                'aria-hidden': isActive ? 'false' : 'true'
            });

            if (!isActive) {
                content.hide();
            }
        });
    },
    remove: function() {
        this.items.each(function(){
            $(this).find('[data-role="accordion-title"]').removeAttr('role tabindex aria-controls aria-expanded id');
            $(this).find('[data-role="accordion-content"]').removeAttr('style aria-hidden aria-labelledby id');

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        })
    }
};